const { getElement } = window.BAO.Utils
export class ShippingSelector extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.onSelection = this.onSelection.bind(this)

    if (this.els?.items.exists) {
      this.els.items.elements.forEach(itemsEl => {
        this.listeners.add(itemsEl, 'click', this.onSelection)
      })
    }
  }

  onSelection (e) {
    if (!e.target.matches('[data-shipping-selector-el="button"]')) return

    const countryCode = e.target.dataset.countryCode

    const form = e.target.closest('form')

    // Construct value to post with form
    const val = document.createElement('input')

    val.setAttribute('type', 'hidden')
    val.setAttribute('name', 'country_code')
    val.setAttribute('value', countryCode)

    form.appendChild(val)

    this.updateLocationModal()

    e.target.closest('form').submit()
  }

  updateLocationModal () {
    const locationModalEl = getElement('location-modal')

    if (locationModalEl) {
      locationModalEl.close()
      locationModalEl.setStorage()
    }
  }
}

if (!customElements.get('shipping-selector')) {
  customElements.define('shipping-selector', ShippingSelector)
}
